import { topicListApi, articleListApi, topicInfoApi, articleInfoApi, articleCommentListApi, articleNotaryListApi } from '@/api/guide/index'
// initial state
const state = {
  topicList: [],
  articleList: [],
  topicInfo: {
    specialTopic: {}
  },
  articleInfo: {},
  articleComment: {},
  articleNotaryList: []
}

// getters
const getters = {}

// actions
const actions = {
  // 获取专题
  topicListAction ({ commit }) {
    return new Promise((resolve, reject) => {
      topicListApi().then(response => {
        if (response.status === '2000') {
          commit('setTopicList', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取专题详情
  topicInfoAction ({ commit }, qurey) {
    return new Promise((resolve, reject) => {
      topicInfoApi(qurey).then(response => {
        if (response.status === '2000') {
          commit('setTopicInfo', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取公证知识与问题
  articleListAction ({ commit }, query) {
    return new Promise((resolve, reject) => {
      articleListApi(query).then(response => {
        if (response.status === '2000') {
          commit('setArticleList', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取公证知识与问题详情
  articleInfoAction ({ commit }, query) {
    return new Promise((resolve, reject) => {
      articleInfoApi(query).then(response => {
        if (response.status === '2000') {
          commit('setArticleInfo', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取公证知识与问题详情评论
  articleCommentAction ({ commit }, query) {
    return new Promise((resolve, reject) => {
      articleCommentListApi(query).then(response => {
        if (response.status === '2000') {
          commit('setArticleComment', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取公证知识与问题详情相关业务
  articleNotaryListAction ({ commit }, query) {
    return new Promise((resolve, reject) => {
      articleNotaryListApi(query).then(response => {
        if (response.status === '2000') {
          commit('setArticleNotaryListInfo', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

// mutations
const mutations = {
  setTopicList (state, topicList) {
    state.topicList = topicList
  },
  setTopicInfo (state, topicInfo) {
    state.topicInfo = topicInfo
  },
  setArticleList (state, articleList) {
    state.articleList = articleList
  },
  setArticleInfo (state, articleInfo) {
    state.articleInfo = articleInfo
  },
  setArticleComment (state, articleComment) {
    state.articleComment = articleComment
  },
  setArticleNotaryListInfo (state, articleNotaryList) {
    state.articleNotaryList = articleNotaryList
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/guide/index.js